import React, {useEffect, useState} from 'react';
import { Spinner, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getFuncFichaEmpleado } from '../../../redux/func_ficha_empleados/actions';
import CustomNavbar from '../../../components/CustomNavbar';
import SidebarDashboard from '../../../components/SidebarDashboard';
import UserHeadDetail from '../../../components/UserHeadDetail';
import UserHeadDetailMenu from '../../../components/UserHeadDetailMenu';
import { Link } from 'react-router-dom';

const EmployeeTab = props => {
  //Redux
 const dispatch = useDispatch();
 const data = useSelector(store => store.funcTabEmployeed.ficha_empleado);
 const loading = useSelector(store => store.funcTabEmployeed.loadingFicha_Empleado);

  useEffect(() => {
    dispatch(getFuncFichaEmpleado(props.match.params.id, parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.id, props.match.params.type]);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ): (<>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu id={props.match.params.id} type={props.match.params.type} />
                <div className="mt-4 mb-3">
                  <div className="d-flex aling-items-center justify-content-between px-2">
                    <h5 className="font-weight-bold">FICHA DE EMPLEADO</h5>
                    <div>
                      <span className="text-muted mr-3"><i className="material-icons">vpn_key</i> Código: {data.codigo}</span>
                      <span className="text-muted mr-3"><i className="material-icons">timer</i> Antiguedad:  {parseInt(data.antiguedad_laboral) < 1 ? ` ${parseInt(data.antiguedad_laboral)} meses` : ` ${parseInt(parseInt(data.antiguedad_laboral) / 12)} años`}
                        {Math.floor(((parseInt(data.antiguedad_laboral) / 12) - parseInt(parseInt(data.antiguedad_laboral) / 12)) * 12) > 0 ? ` ${Math.floor(((parseInt(data.antiguedad_laboral) / 12) - parseInt(parseInt(data.antiguedad_laboral) / 12)) * 12)} meses`: null} 
                      </span>
                      <span className="text-muted"><i className="material-icons">moving</i> Rel. Laboral: {data.Relacion_Laboral_List ? data.Relacion_Laboral_List[0].descripcion : 'No ingresado aún'}</span>
                    </div>
                  </div>
                  <hr className="mb-3" />
                  <Row>
                    <Col>
                      <Link to={`/general-info-empleado/${props.match.params.id}/${props.match.params.type}`} className="btn btn-primary btn-lg btn-block">Datos Generales</Link>
                      {/* <Link className="btn btn-primary btn-lg btn-block">Contactos</Link> */}
                      <Link to={`/empleado-familiares/${props.match.params.id}/${props.match.params.type}`} className="btn btn-primary btn-lg btn-block">Datos Familiares</Link>
                      <Link to={`/empleado-salud/${props.match.params.id}/${props.match.params.type}`} className="btn btn-primary btn-lg btn-block">Salud</Link>
                    </Col>
                    <Col>
                      <Link to={`/empleado-educacion/${props.match.params.id}/${props.match.params.type}`} className="btn btn-primary btn-lg btn-block">Educación</Link>
                      <Link to={`/empleado-contactos-emergencia/${props.match.params.id}/${props.match.params.type}`} className="btn btn-primary btn-lg btn-block">Emergencia</Link>
                      <Link to={`/empleado-historial-laboral/${props.match.params.id}/${props.match.params.type}`} className="btn btn-primary btn-lg btn-block">Experiencia Laboral</Link>
                    </Col>
                  </Row>
                </div>
              </div>
            </>)
          }
        </div>
      </div>
    </>
  )
}

export default EmployeeTab
